import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { amlButtonSx } from './amlScreeningStyles';

export default function AmlReScreenConfirmModal({ open, onClose, labels, onConfirm, isRunning }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>{labels.title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          {labels.description}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, pt: 1, gap: 1 }}>
        <Button variant="outlined" onClick={onClose} disabled={isRunning} sx={amlButtonSx}>
          {labels.cancel}
        </Button>
        <Button variant="contained" color="primary" onClick={onConfirm} disabled={isRunning} sx={amlButtonSx}>
          {labels.confirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
